import React from 'react'
import MarginOptions from './MarginOptions'
import RightBarGroup from './RightBarGroup'
import Input from './Input'
import Textarea from './Textarea'
import {
  ChangeEvent,
  DynamicContentType,
  FileEntryBM,
  ImageCard,
  ImageCardsData,
  jsonCopy,
} from '@bm-js/atlascloud-shared'
import { useTr } from '../utils/useTr'
import { TrKey } from '../cnst/translations/trKey.cnst'

type Props = {
  content: DynamicContentType<ImageCardsData>
  setData: (e: ChangeEvent<ImageCard[] | string>) => void
}

const ImageCardsEditor = ({ content, setData }: Props) => {
  const { tr } = useTr()

  const onChange = (
    e: ChangeEvent<FileEntryBM | string>,
    i: number,
    key: keyof ImageCard
  ) => {
    const { value } = e.target
    const updated = jsonCopy(content.data)

    if (key === 'image') {
      updated.cards[i].image = value as FileEntryBM
    } else {
      updated.cards[i][key] = value as string
    }

    const updateEvent = {
      target: {
        name: 'cards',
        value: updated.cards,
      },
    }
    setData(updateEvent)
  }

  return (
    <>
      {content.data.cards.map((_card, i) => (
        <React.Fragment key={`imagecard_edit_${content.uuid}_${i}`}>
          <RightBarGroup title={`${tr(TrKey.imageCardsEditorCard)} #${i + 1}`}>
            <Input
              type='image'
              setter={(f) =>
                onChange({ target: { name: 'cards', value: f } }, i, 'image')
              }
              value={content.data.cards[i].image}
            />
            <Input
              light
              label={tr(TrKey.imageCardsEditorHeader)}
              id={`imageCard_h_${i}`}
              value={content.data.cards[i].header}
              onChange={(e) => onChange(e, i, 'header')}
            />
            <Textarea
              light
              label={tr(TrKey.imageCardsEditorParagraph)}
              id={`imageCard_p_${i}`}
              value={content.data.cards[i].paragraph}
              onChange={(e) => onChange(e, i, 'paragraph')}
            />
            <Input
              light
              label={tr(TrKey.imageCardsEditorButtonText)}
              id={`imageCard_btntext_${i}`}
              value={content.data.cards[i].buttonText}
              onChange={(e) => onChange(e, i, 'buttonText')}
            />
            <Input
              light
              label={tr(TrKey.imageCardsEditorButtonLink)}
              id={`imageCard_btnhref_${i}`}
              value={content.data.cards[i].buttonLink}
              onChange={(e) => onChange(e, i, 'buttonLink')}
            />
          </RightBarGroup>
        </React.Fragment>
      ))}
      <MarginOptions content={content} setData={setData} />
    </>
  )
}

export default ImageCardsEditor
